<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="container-fluid spacer-top-navigation" [zeroLoadingIndicator]="loading()">
  <div class="container">
    <div class="tile content">
      <ng-content />
      <div class="mt-4">
        @if (store.error$ | async; as error) {
          <div class="zero-text course-red mb-3">{{ error | transloco }}</div>
        }
        <div class="d-flex justify-content-between align-items-center">
          <div>
            @if (!hideBack()) {
              <div class="back-circle" (click)="back.emit()">
                <web-design-system-icon name="chevron-3" />
              </div>
            }
          </div>
          <div class="d-flex justify-content-end align-items-center gap">
            @if (!hideForward()) {
              <web-design-system-button [disabled]="!formValid()" [fullwidth]="true" (click)="forward.emit()">
                {{ buttonLabel() ?? 'child-onboarding.next' | transloco }}
              </web-design-system-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
